const ProjectsAPI = [
    {
        img: "../img/portfolio/7.webp",
        title: "01 Milestone Apps",
        link: "https://milestoneapps.com/",
        alt: "Milestone Apps",
        paragraph: "I have launched Milestone Apps, a project aimed at delivering efficient and user-friendly mobile applications for various purposes."
    },
    {
        img: "../img/portfolio/6.webp",
        title: "02 Dejure Technology",
        link: "https://www.dejuretechnologies.com/",
        alt: "Dejure Technology",
        paragraph: "I have developed a project called Dejure Technology, centered around cutting-edge tech solutions and innovation."
    },
    {
        img: "../img/portfolio/5.webp",
        title: "03 DI-BIG LLC",
        link: "https://dibig.netlify.app/",
        alt: "DI-BIG LLC",
        paragraph: "DI-BIG is my project focusing on Data Intelligence and Big Data Analytics to unlock valuable insights and enhance decision-making."
    },
    {
        img: "../img/portfolio/8.webp",
        title: "04 PNY Training Institute",
        link: "https://www.pnytrainings.com/",
        alt: "PNY Training Institute",
        paragraph: "I have established PNY Training Institute, offering a diverse range of courses to enhance skills and knowledge."
    },
    {
        img: "../img/portfolio/4.webp",
        title: "05 Rizwan De-Cafe",
        alt: "Rizwan De-Cafe",
        link: "https://rizwan-de-cafe.netlify.app/",
        paragraph: "I have established Rizwan De-Cafe, offering a diverse range of courses to enhance skills and knowledge."
    },
    {
        img: "../img/portfolio/9.webp",
        alt: "Website Access",
        title: "06 Website Access",
        link: "https://www.websiteaccess.co.uk/",
        paragraph: "Visit our software house website for cutting-edge solutions and innovation in data intelligence and analytics."
    },
    {
        img: "../img/portfolio/3.webp",
        alt: "Usman Ghani",
        title: "07 Usman Ghani",
        link: "https://smart-update-service.netlify.app/",
        paragraph: "I have launched Usman Ghani, a project aimed at delivering efficient and user-friendly mobile applications for various purposes."
    },
    {
        img: "../img/portfolio/10.webp",
        alt: "Sell-Buy-Repair",
        title: "08 Sell-Buy-Repair",
        link: "https://sell-buy-repair.netlify.app/",
        paragraph: "Buy, sell, and repair with ease! Our website offers seamless solutions for all your selling, buying, and repairing needs."
    },
    {
        img: "../img/portfolio/11.webp",
        alt: "Vap Shop",
        title: "09 Vap Shop",
        link: "https://vapshop.netlify.app/",
        paragraph: "Discover Vape On Shop, your ultimate destination for all things vaping. Explore, shop, and enjoy a world of flavors."
    },
    {
        img: "../img/portfolio/12.webp",
        alt: "MA Estimation",
        title: "10 MA Estimation",
        link: "https://mehrankhan.netlify.app/",
        paragraph: "Get accurate estimates effortlessly. Explore our website for precise estimation tools and make informed decisions with confidence."
    },
    {
        img: "../img/portfolio/13.webp",
        alt: "Digital-Skills-Institute",
        title: "11 Digital Skills Institute",
        link: "https://digital-skills-institute.netlify.app/",
        paragraph: "Digital-Skills-Institute: Igniting passions, shaping futures. Empowering learners to thrive in the dynamic world of web development."
    },
    {
        img: "../img/portfolio/14.webp",
        alt: "Aiman Fareed Marketer",
        title: "12 Aiman Fareed Marketer",
        link: "https://aimanfareed.netlify.app/",
        paragraph: "My website is a digital playground, where creativity dances with strategy. It's a cozy corner where brands find their voice and dreams take flight."
    }
    ,
    {
        img: "../img/portfolio/15.webp",
        alt: "Mobile Bitz",
        title: "13 Mobile Bitz",
        link: "https://mobilebitz.co.uk/",
        paragraph: "My project showcases a website exquisitely designed, marrying form and function effortlessly. It's a digital gem, inviting users into a world of beauty and usability."
    }
]
export default ProjectsAPI;